import { COLORS } from 'Components/utils/color/colors';

export const themes = {
  default: {
    thTitle: 'mb-5',
    thList: 'reset-list sm:colum-count-2 -m-1',
    thListItem: 'flex p-1',
    thIcon: 'bg-emerald flex-shrink-0 p-1 rounded-full rtl:mr-2',
    thIconColor: COLORS.WHITE,
    thIconWidth: '1em',
  },
};
